import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=ee46b400&scoped=true"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=ee46b400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee46b400",
  null
  
)

export default component.exports